const palette = {
  red: {
    normal: '#8C1515',
    light: '#BD8282',
    dark: '#751212',
  },
  yellow: {
    normal: '#D2C295',
    dark: '#A79E70',
  },
  grey: {
    normal: '#4D4F53',
  },
  orange: {
    normal: '#E17000',
    dark: 'C75B12',
  },
  purple: {
    normal: '#6E2585',
    dark: '#5B1F69',
  },
  blue: {
    normal: '#0099CC',
    dark: '#006983',
  },
  green: {
    normal: '#69BE28',
    dark: '#5B8F22',
  },
}

export const red = palette.red
export const yellow = palette.yellow
export const grey = palette.grey
export const orange = palette.orange
export const purple = palette.purple
export const blue = palette.blue
export const green = palette.green

export default palette
